import { Component, ElementRef, OnInit, TemplateRef, ViewChild, Input } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { MeetingRoom, MeetingLocation, MeetingType } from '../models/MasterMOM';
import { MasterMOMService } from '../services/master-mom.service';
import { UserService } from '../services/user.service';
import { AttendeesAtd, GenInfoAtd, AgendaDetails, FileAttachement, MeetingAppoinments, MeetingAttendee, outlookAttendeeInsert, cmtObject } from '../models/MOMForm';
import { NgForm } from '@angular/forms';
import { formatDate } from '@angular/common';
import { ToastrUtilsService } from '../services/toastr-utils.service';
import { UtilityService } from '../services/utility.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import Notiflix from "notiflix";
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import htmlToPdfmake from 'html-to-pdfmake';
import { fixUp } from '../../../src/assets/v2/js/fix-lists';

@Component({
  selector: 'app-view-attendence',
  templateUrl: './view-attendence.component.html',
  styleUrls: ['./view-attendence.component.css'],
  providers: [ToastrUtilsService]
})
export class ViewAttendenceComponent implements OnInit {

  @ViewChild('template', { static: false }) template: TemplateRef<any>;
  @ViewChild('templateReason', { static: false }) templateReason: TemplateRef<any>;
  @ViewChild('templateFile', { static: false }) templateFile: TemplateRef<any>;
  @ViewChild('templateActionPoint', { static: false }) templateActionPoint: TemplateRef<any>;
  @ViewChild('templateAdd', { static: false }) templateAdd: TemplateRef<any>;
  @Input() inpUserList: any;
  modalRef: BsModalRef;
  modalPub: BsModalRef;
  modalPrivate: BsModalRef;
  modalMeeting: BsModalRef;
  modalImport: BsModalRef;
  @Input() pagetype: string;
  searchText: string = '';
  viewSelected: boolean = true;
  editSelected: boolean = false;
  modalAdd: BsModalRef;
  selTab1: boolean = true;
  selTab2: boolean = false;
  selTab3: boolean = false;
  selTab4: boolean = false;
  selTab5: boolean = false;

  momTab1: boolean = true;
  momTab2: boolean = false;
  momTab3: boolean = false;

  addTab1: boolean = true;
  addTab2: boolean = false;
  isFileUpload: boolean = true;
  editDiv1: boolean = true;
  editDiv2: boolean = false;
  public text: string = 'Edit';
  loginUserId: any;
  locationdaList: any = [];
  meetingRoomList: any = [];
  meetingTypeList: any = [];
  UserList: any = [];
  model: GenInfoAtd = new GenInfoAtd();
  isSubmit: boolean = false;
  isSubmitInternal: boolean = false;
  isSubmitReview: boolean = false;
  isSubmitApprover: boolean = false;
  isSubmitFollower: boolean = false;
  isSubmitExternal: boolean = false;
  isSubmitReason: boolean = false;
  isSubmitAP: boolean = false;
  today = formatDate(new Date(), 'yyyy-MM-dd', 'en-US');
  enableAP: boolean = true;

  show: boolean = false;
  selectedInternalUser: any;
  selectedReviewer: any;
  selectedApprover: any;
  selectedFollower: any;
  atdStartIndex = 1;
  atdMaxCount = 100;
  disableMoreAtd = true;
  attendeeList: any = [];
  actionPointsList: any = [];
  attendeeDDList: any = [];
  followerList: any = [];
  reviewerList: any = [];
  fileList: any = [];
  actionFileList: any = [];
  public uploadedFiles: Array<File> = [];
  approver: any;
  attendeeModel: AttendeesAtd = new AttendeesAtd();
  atdReasonModel: AttendeesAtd = new AttendeesAtd();
  apModel: AgendaDetails = new AgendaDetails();
  selectedReason: string = '';
  loginUsrEmail: string = '';
  disableOutlook: boolean = false;
  commentStartIndex: number = 1;
  commentMaxCount: number = 100;
  commentList: any = [];
  @Input() viewType: string;
  public commentType: string = 'Everyone';
  commentText: string = '';
  commentAttendeeList: any = [];
  loginUsrName: any;
  noDataImage: string;
    docType: number =0;
    commentChatList: any=[];
    isProfileCard: boolean=false;
    attendanceEditUno: number;
  isModalShow: boolean;
  public ngbModalOptions: any = {
    backdrop: 'static',
    keyboard: false
  };
  attachmentUno: number;
  fileRename: BsModalRef;
  model1: any = {};
  get mid(): number {
    return this.model.genInfoAtdUno;
  }
  @Input() set mid(value: number) {
    this.model.genInfoAtdUno = value;

  }
  public commentTypeClass: string = 'ti ti-unlock fa-lg mx-1';
  isLoading: boolean = false;
  constructor(private modalService: BsModalService,
    private userService: UserService,
    private toastr: ToastrUtilsService,
    public utilityService: UtilityService,
    private momService: MasterMOMService) { }

  ngOnInit(): void {
    this.noDataImage = this.utilityService.getnodataImage();
    var user = this.userService.getUserInfo();
    if(user==undefined){
      this.userService.logout();
    }
    else{
      this.loginUserId = user.id;
      this.loginUsrEmail = user.email;
      this.loginUsrName = user.firstname;
    } 
    this.getMeetingLocation();
    this.getMeetingRoom();
    if (this.inpUserList == null || this.inpUserList == undefined || this.inpUserList.length == 0) {
      this.getUserList();
    }
    else {
      this.UserList = this.inpUserList;
    }
    this.getMeetingType();
    if (this.viewType == "edit") {
      this.momTab1 = true;
      this.momTab2 = false;
      this.momTab3 = false;
      this.viewSelected = !this.viewSelected;
      this.editSelected = !this.editSelected;

      if (this.text === 'Edit') {
        this.text = 'Cancel'
      } else {
        this.text = 'Edit'
      };
    }
    if (this.model.genInfoAtdUno && this.model.genInfoAtdUno > 0) {
      this.getGeneralInfo();
      this.getAttendeDDList();
      this.getAttendeeList();
      this.getActionPointsList();
      //this.getUserList();
      this.getAttachFiles();

    }
  }

  openModal(template2: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template2, Object.assign({}, { class: 'gray modal-xl modal-full modal-dialog-scrollable' })
    );
    //this.modalPub.hide();
  }
  openModalnewMeeting(template1: TemplateRef<any>) {
    this.modalMeeting = this.modalService.show(template1, Object.assign({}, { class: 'gray modal-xl modal-dialog-scrollable' })
    );
  }

  openPubModal(template: TemplateRef<any>) {
    this.modalPub = this.modalService.show(template, { class: 'modal-md' });

  }
  openPrivateModal(templatePrivate: TemplateRef<any>) {
    this.modalPrivate = this.modalService.show(templatePrivate, { class: 'modal-md' });

  }
  dragDropConfig = {
    showList: true,
    showProgress: true
  }

  // Get Location list
  getMeetingLocation() {
    let inpValue = new MeetingLocation();
    inpValue.languageUno = 1033;
    inpValue.userUno = this.loginUserId;
    this.momService.getLocation(inpValue)
      .subscribe(data => {
        this.locationdaList = data;
      },
        () => {
        }
      ).add(() => {
      });
  }

  // Get MeetingRoom list
  getMeetingRoom() {
    let inpValue = new MeetingRoom();
    inpValue.languageUno = 1033;
    inpValue.userUno = this.loginUserId;
    this.momService.getMeetingRoom(inpValue)
      .subscribe(data => {
        this.meetingRoomList = data;
      },
        (error) => {
        }
      ).add(() => {
      });
  }

  // Get Meeting Type list
  getMeetingType() {
    let inpValue = new MeetingType();
    inpValue.languageUno = 1033;
    inpValue.userUno = this.loginUserId;
    this.momService.getMeetingType(inpValue)
      .subscribe(data => {
        this.meetingTypeList = data;
      },
        () => {
        }
      ).add(() => {
      });
  }

  //Get User List
  getUserList() {
    let inpValue = new AttendeesAtd();
    inpValue.userUno = this.loginUserId;
    this.momService.getUserList(inpValue)
      .subscribe(data => {
        this.UserList = data;
      },
        () => {
        }
      ).add(() => {
      });
  }
  cancelAttendee() {
    this.attendeeModel = new AttendeesAtd();
    this.isSubmitExternal = false;
    this.selectedInternalUser = null;
    this.isSubmitInternal = false;
    this.isSubmitReason = false;
    this.atdReasonModel = new AttendeesAtd();
    this.addTab1 = true;
    this.addTab2 = false;
  }
  onSubmitInternal(f: NgForm, role, value) {
    if (f.valid) {
      let UserObj = this.UserList.filter((item) => item.userselUno == value)[0];
      let objAttendeesAtd = new AttendeesAtd();
      objAttendeesAtd.actionType = this.pagetype;
      objAttendeesAtd.attendeesUnoAtd = 0;
      objAttendeesAtd.prNumberAtd = this.utilityService.isStringNull(UserObj.prNumberAtd);
      objAttendeesAtd.status = 'Present';
      objAttendeesAtd.role = role;
      objAttendeesAtd.genInfoAtdUno = this.model.genInfoAtdUno;
      objAttendeesAtd.userselUno = this.utilityService.isNumericNull(UserObj.userselUno);
      objAttendeesAtd.nameAtd = this.utilityService.isStringNull(UserObj.nameAtd);
      objAttendeesAtd.companyAtd = "DEWA";
      objAttendeesAtd.emailAtd = this.utilityService.isStringNull(UserObj.emailAtd);
      objAttendeesAtd.userUno = this.loginUserId;
      this.momService.addEditAttendeesAtd(objAttendeesAtd)
        .subscribe(data => {
          if (data == 'duplicate') {
            this.toastr.ErrorCustomMessage('User already exists. Please select different User')
          }
          else {
            this.cancelAttendee();
            this.atdStartIndex = 1;
            this.toastr.SaveMessage();
            this.getAttendeeList();
            this.getAttendeDDList();
          }
        },
          (error) => {
            this.isSubmitInternal = false;
            if (error.error.text == 'duplicate') {
              this.toastr.ErrorCustomMessage('User already exists. Please select different User')
            }
          }
        ).add(() => {
          this.isSubmitInternal = false;
        });
    }
    else {
      this.toastr.ValidationMessage();
      this.isSubmitInternal = true;
    }
  }

  onSubmitExternal(f: NgForm) {
    if (f.valid) {
      if (this.attendeeModel.nameAtd.trim() != '' && this.attendeeModel.companyAtd.trim() != '' && this.attendeeModel.emailAtd.trim() != '' && this.attendeeModel.contactAtd.trim() != '') {
      this.attendeeModel.prNumberAtd = "";
      this.attendeeModel.status = 'Present';
      this.attendeeModel.role = 'Attendee';
      this.attendeeModel.genInfoAtdUno = this.model.genInfoAtdUno;
      this.attendeeModel.contactAtd = this.utilityService.isNumericNull(this.attendeeModel.contactAtd).toString();
      this.attendeeModel.userUno = this.loginUserId;
      this.attendeeModel.actionType = this.pagetype;
      this.momService.addEditAttendeesAtd(this.attendeeModel)
        .subscribe(data => {
          if (data == 'duplicate') {
            this.toastr.ErrorCustomMessage('Attendee already exists. Please select different Attendee')
          }
          else {
            this.cancelAttendee();
            this.toastr.SaveMessage();
            this.atdStartIndex = 1;
            this.getAttendeeList()
            this.getAttendeDDList();
          }
        },
          (error) => {
            this.isSubmitExternal = false;
            if (error.error.text == 'duplicate') {
              this.toastr.ErrorCustomMessage('Attendee already exists. Please select different Attendee')
            }
          }
        ).add(() => {
          this.isSubmitExternal = false;
        });
    }
    else {
      this.toastr.ErrorCustomMessage('Please enter required values');
    }
    }
    else {
      this.toastr.ValidationMessage();
      this.isSubmitExternal = true;
    }
  }

  onSubmitApprover(f: NgForm, role, value) {
    if (f.valid) {
      this.onSubmitInternal(f, role, value);
      this.isSubmitApprover = false;
      this.selectedApprover = null;
    }
    else {
      this.toastr.ErrorCustomMessage('select the approver');
      this.isSubmitApprover = true;
    }
  }

  onSubmitReviewer(f: NgForm, role, value) {
    if (f.valid) {
      this.onSubmitInternal(f, role, value);
      this.isSubmitReview = false;
      this.selectedReviewer = null;
    }
    else {
      this.toastr.ErrorCustomMessage('select the reviewer');
      this.isSubmitReview = true;
    }
  }
  onSubmitFollower(f: NgForm, role, value) {
    if (f.valid) {
      this.onSubmitInternal(f, role, value);
      this.isSubmitFollower = false;
      this.selectedFollower = null;
    }
    else {
      this.toastr.ErrorCustomMessage('select the follower');
      this.isSubmitFollower = true;
    }
  }
  getShortName(val) {
    let valArray = val.trim().split(' ');
    if (valArray.length > 1)
      return valArray[0].charAt(0).toUpperCase() + valArray[1].charAt(0).toUpperCase()
    else
      return val.charAt(0).toUpperCase() + val.charAt(1).toUpperCase()

  }

  attendeeReason(model) {
    this.atdReasonModel = model;
    this.modalRef = this.modalService.show(this.templateReason, { class: 'modal-md' });
  }
  editAttendee(model) {
    this.addTab1 = false;
    this.addTab2 = true;
    this.attendeeModel = model;
  }

  ChangeAttendeeStatus(model) {
    if (model.status == 'On Behalf' || model.status == 'Apologized') {
      this.atdReasonModel = model;
      this.atdReasonModel.apologizedReason = '';
      this.modalRef = this.modalService.show(this.templateReason, { class: 'modal-md' });
    }
    else {
      this.UpdateAttendees('attendance', model.status, model)
    }
  }
  submitAttendeeReason(f: NgForm) {
    if (f.valid) {
      this.UpdateAttendees('attendance', this.atdReasonModel.status, this.atdReasonModel)
      this.modalRef.hide();
    }
    else {
      this.toastr.ValidationMessage();
      this.isSubmitReason = true;
    }
  }

  closeAttendeeReason() {
    this.cancelAttendee();
    this.modalRef.hide();
    this.atdStartIndex = 1;
    this.getAttendeeList();
  }

  UpdateAttendees(type, value, Attendee) {
    let inpValue = new AttendeesAtd();
    inpValue.actionType = this.pagetype;
    inpValue.genInfoAtdUno = Attendee.genInfoAtdUno;
    inpValue.updateType = type;
    inpValue.attendeesUnoAtd = Attendee.attendeesUnoAtd;
    inpValue.role = value;
    inpValue.status = value;
    inpValue.signImage = value;
    inpValue.userUno = this.loginUserId;
    inpValue.apologizedReason = Attendee.apologizedReason;
    this.momService.AttendeColumnUpdate(inpValue)
      .subscribe(() => {
        this.toastr.UpdateMessage();
        this.atdStartIndex = 1;
        this.getAttendeeList();
        this.cancelAttendee();
      },
        () => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }


  delAttendee(id: any) {
    let that = this;
    Notiflix.Confirm.Show('Confirm ', 'Are you sure you want to delete?', 'Yes', 'No', function () {
      let inpValue = new AttendeesAtd();
      inpValue.userUno = that.loginUserId;
      inpValue.attendeesUnoAtd = id;
      inpValue.actionType = that.pagetype;
      that.momService.deleteAttendeesAtd(inpValue)
        .subscribe(data => {
          that.toastr.DeleteMessage();
          that.atdStartIndex = 1;
          that.getAttendeeList();
          that.getAttendeDDList();
        },
          () => {
            that.toastr.ErrorMessage();
          }
        ).add(() => {
        });
    },
      function () { //('If you say so...');
      });



  }
  // GetAttendees list
  getAttendeeList() {
    Notiflix.Block.Dots('.attendeesListLoader');
    this.attendeeList = [];
    let inpValue = new AttendeesAtd();
    inpValue.userUno = this.loginUserId;
    inpValue.genInfoAtdUno = this.model.genInfoAtdUno;
    this.atdStartIndex = (this.atdStartIndex == undefined || this.atdStartIndex < 1) ? 1 : this.atdStartIndex;
    inpValue.startIndex = this.atdStartIndex;
    inpValue.maxCount = this.atdMaxCount;
    inpValue.actionType = this.pagetype;

    this.momService.getAttendeesAtd(inpValue)
      .subscribe(data => {
        let objData: any = data;
        if (this.atdStartIndex == 1) {
          this.attendeeList = objData;
        }
        else {
          for (var i = 0; i < objData.length; i++) {
            this.attendeeList.push(objData[i]);
          }
        }
        //if the result set is lessthen 100 then disable the load more icon
        this.disableMoreAtd = (objData.length >= 100) ? false : true;
        if (objData.length > 0) {
          //this.ifcountgreaterthanzero = true;
          this.atdStartIndex = this.atdStartIndex + 1;
        }
        Notiflix.Block.Remove('.attendeesListLoader', 800);
      },
        () => {

        }
      ).add(() => {

      });

  }

  exportAttendee() {


    let items: any = [];
    for (var i = 0; i < this.attendeeDDList.length; i++) {
      if (this.pagetype == 'ATTENDANCE') {
        items.push({
          PRN: this.attendeeDDList[i].prNumberAtd,
          Name: this.attendeeDDList[i].nameAtd,
          Organization: this.attendeeDDList[i].companyAtd,
          Email: this.attendeeDDList[i].emailAtd,
          Designation: this.attendeeDDList[i].designation,
          Contact: this.attendeeDDList[i].contactAtd,
          Attendance: this.attendeeDDList[i].status,
          Role: this.attendeeDDList[i].role,
          Reason: this.attendeeDDList[i].status + '-' + this.attendeeDDList[i].apologizedReason,
        });
      }
      else {
        items.push({
          PRN: this.attendeeDDList[i].prNumberAtd,
          Name: this.attendeeDDList[i].nameAtd,
          Organization: this.attendeeDDList[i].companyAtd,
          Designation: this.attendeeDDList[i].designation,
          Email: this.attendeeDDList[i].emailAtd,
          Contact: this.attendeeDDList[i].contactAtd,
          Attendance: this.attendeeDDList[i].status,
          Reason: this.attendeeDDList[i].status + '-' + this.attendeeDDList[i].apologizedReason,
        });

      }
    }
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(items);
    const workbook: XLSX.WorkBook = { Sheets: { 'Attendee': worksheet }, SheetNames: ['Attendee'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    FileSaver.saveAs(blob, this.model.subjectAtd + '_AttendeeList.xlsx');

  }

  // GetAttendees DD
  getAttendeDDList() {
    this.commentAttendeeList = [];
    let inpValue = new AttendeesAtd();
    inpValue.userUno = this.loginUserId;
    inpValue.genInfoAtdUno = this.model.genInfoAtdUno;
    inpValue.startIndex = 1;
    inpValue.condition = 1;
    inpValue.maxCount = 10000;
    inpValue.actionType = this.pagetype;

    this.momService.getAttendeDD(inpValue)
      .subscribe((data: any) => {
        if (data && data.length > 0) {
          this.attendeeDDList = data.filter(x => x.role != 'Approver' && x.role != 'Reviewer' && x.role != 'Follower');
          this.reviewerList = data.filter(x => x.role == 'Reviewer');
          this.followerList = data.filter(x => x.role == 'Follower');
          let approver = data.filter(x => x.role == 'Approver');
          if (approver && approver.length > 0)
            this.approver = approver[0];
          else
            this.approver = null;

          for (var i = 0; i < this.attendeeDDList.length; i++) {

            this.commentAttendeeList.push({
              id: this.attendeeDDList[i].attendeesUnoAtd,
              name: this.attendeeDDList[i].nameAtd,
              check: false
            });
          }
          this.commentChatList = this.commentAttendeeList;
        }
      },
        () => {
        }
      ).add(() => {
      });
  }

  AddComment() {
    let commentUsers = [];
    this.commentAttendeeList.forEach(function (item: any) {
      if (item.check)
        commentUsers.push(item.attendeesUnoAtd);
    });
    let inpValue = new cmtObject();
    if (this.commentText.trim() == '') {
      this.toastr.ErrorCustomMessage('Please enter the comment.');
      return;
    }
    if (this.commentType == 'Private' && (commentUsers == null || commentUsers.length == 0)) {
      this.toastr.ErrorCustomMessage('Please select users.');
      return;
    }
    if (this.commentType == 'Self') {
      inpValue.cmtUsers = this.loginUserId.toString();
    }
    else if (this.commentType == 'Private') {
      inpValue.cmtUsers = commentUsers.toString();
    }
    else {
      inpValue.cmtUsers = null;
    }
    let chatType = 0;
    if (this.commentType == 'Everyone') {
      chatType = 0;
    }
    else if (this.commentType == 'Self') {
      chatType = 1;
    }
    else if (this.commentType == 'Private') {
      chatType = 2;
    }
    inpValue.userId = this.loginUserId;
    inpValue.genralInfoId = this.model.genInfoAtdUno;
    inpValue.cmdId = 0;
    inpValue.cmdText = this.commentText;
    inpValue.actionType = this.pagetype;
    inpValue.chatType = chatType;
    this.momService.insertAtdComment(inpValue)
      .subscribe(data => {
        this.toastr.SaveMessage();
        this.commentStartIndex = 1;
        this.getCommentList();
        this.commentText = '';

      },
        () => {
          this.toastr.ErrorMessage();
        }
      ).add(() => {

      });

  }

  getCommentList() {
    let inpValue = new cmtObject();
    inpValue.userId = this.loginUserId;
    inpValue.genralInfoId = this.model.genInfoAtdUno;
    inpValue.cmdId = 0;
    this.commentStartIndex = (this.commentStartIndex == undefined || this.commentStartIndex < 1) ? 1 : this.commentStartIndex;
    inpValue.startIndex = this.commentStartIndex;
    inpValue.maxCount = this.commentMaxCount;
    inpValue.actionType = this.pagetype;

    this.momService.getAtdComment(inpValue)
      .subscribe((data: any) => {
        if (this.commentStartIndex == 1) {
          this.commentList = data;
        }
        else {
          for (var i = 0; i < data.length; i++) {
            this.commentList.push(data[i]);
          }
        }
        if (data.length > 0) {
          //this.ifcountgreaterthanzero = true;
          this.commentStartIndex = this.commentStartIndex + 1;
        }

      },
        () => {
          this.toastr.ErrorMessage();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });

  }



  delAtdComment(id: any) {
    let that = this;
    Notiflix.Confirm.Show('Confirm ', 'Are you sure you want to delete?', 'Yes', 'No', function () {
    let inpValue = new cmtObject();
      inpValue.userId = that.loginUserId;
      that.commentStartIndex = 1;
      inpValue.genralInfoId = that.model.genInfoAtdUno;
    inpValue.cmdId = id;
      inpValue.actionType = that.pagetype;


      that.momService.delAtdComment(inpValue)
      .subscribe(data => {

        that.toastr.DeleteMessage();
        that.getCommentList();
      },
        () => {

          that.toastr.ErrorMessage();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
    },
      function () { //('If you say so...');
      });

  }
  closeModal() {
    let btn = document.getElementById('editclose')
    if (btn)
      btn.click();
    this.modalService.hide(1)
  }

  getErrorStatus() {
    if (this.model.fStartTimeAtd && this.model.fEndTimeAtd && this.model.fStartTimeAtd >= this.model.fEndTimeAtd) {
      return true;
    }
    else {
      return false;
    }
  }

  // Get GeneralInfo list
  getGeneralInfo() {
    ;
    Notiflix.Block.Dots('.meetingdetails');
    let inpValue = new GenInfoAtd();
    inpValue.actionType = this.pagetype;
    inpValue.userUno = this.loginUserId;
    inpValue.genInfoAtdUno = this.model.genInfoAtdUno;
    inpValue.recordType = 0;
    this.momService.getGeneralInfoAtd(inpValue)
      .subscribe((data: any) => {
        this.model = data[0];
        this.model.fMeetingDateAtd = formatDate(this.model.fMeetingDateAtd, 'yyyy-MM-dd', 'en-US');
        this.model.startTimeAtd = this.model.fStartTimeAtd;
        this.model.endTimeAtd = this.model.fEndTimeAtd;
        this.model.fStartTimeAtd = formatDate(this.model.fStartTimeAtd, 'HH:mm', 'en-US');;
        this.model.fEndTimeAtd = formatDate(this.model.fEndTimeAtd, 'HH:mm', 'en-US');;
        Notiflix.Block.Remove('.meetingdetails', 800);
        console.log(data[0], "enterby");
        console.log(this.model, "enterby");
      },
        () => {
          Notiflix.Block.Remove('.meetingdetails', 800);
        }
      ).add(() => {
        Notiflix.Block.Remove('.meetingdetails', 800);
        //Called when operation is complete (both success and error)

      });

  }
  onSubmitWorkFlow() {
    this.model.callFrom = '';
    this.model.actionType = this.pagetype;
    this.model.userUno = this.loginUserId;
    this.model.meetingDateAtd = this.utilityService.convertUTCDateTime(this.model.fMeetingDateAtd);
    this.model.startTimeAtd = this.utilityService.convertUTCDateTime(new Date(this.model.fMeetingDateAtd + ' ' + this.model.fStartTimeAtd));
    this.model.endTimeAtd = this.utilityService.convertUTCDateTime(new Date(this.model.fMeetingDateAtd + ' ' + this.model.fEndTimeAtd));
    if (this.model.startTimeAtd >= this.model.endTimeAtd) {
      this.toastr.ErrorCustomMessage('Start time must be less than end time');
      return;
    }
    this.momService.addEditGeneralInfoAtd(this.model)
      .subscribe(data => {
        this.toastr.SaveMessage();
        this.show = true;
        this.isSubmit = false;
        this.model.genInfoAtdUno = Number(data);
        this.getGeneralInfo();
        this.attendeeDDList();
      },
        () => {
          this.toastr.ErrorMessage();
        }
      )
  }
  onSubmitGeneral(gf: NgForm) {
    if (gf.valid) {

      this.model.callFrom = '';
      this.model.actionType = this.pagetype;
      this.model.userUno = this.loginUserId;
      this.model.meetingDateAtd = this.utilityService.convertUTCDateTime(this.model.fMeetingDateAtd);
      this.model.startTimeAtd = this.utilityService.convertUTCDateTime(new Date(this.model.fMeetingDateAtd + ' ' + this.model.fStartTimeAtd));
      this.model.endTimeAtd = this.utilityService.convertUTCDateTime(new Date(this.model.fMeetingDateAtd + ' ' + this.model.fEndTimeAtd));
      if (this.model.startTimeAtd >= this.model.endTimeAtd) {
        this.toastr.ErrorCustomMessage('Start time must be less than end time');
        return;
      }
      this.momService.addEditGeneralInfoAtd(this.model)
        .subscribe(data => {
          this.toastr.SaveMessage();
          this.show = true;
          this.isSubmit = false;
          this.model.genInfoAtdUno = Number(data);
          this.getGeneralInfo();
          this.attendeeDDList();
        },
          () => {
            this.toastr.ErrorMessage();
          }
        )
    }
    else {
      this.toastr.ValidationMessage();
      this.isSubmit = true;
    }
  }
  enablePublish() {
   
    if (this.model.enteredBy == this.loginUserId) {
      if (this.model.published == 0) {
      return true;

      }
      else {
        
        return false;
      }
    }
    else {
      return false;
    }
  }

  getActionPointsList() {
    let inpValue = new AgendaDetails();
    inpValue.genInfoAtdUno = this.model.genInfoAtdUno;
    inpValue.userID = this.loginUserId;
    inpValue.startIndex = 1;
    inpValue.actionType = this.pagetype;
    inpValue.maxCount = 100;
    this.momService.getAgendaDetails(inpValue)
      .subscribe((data: any) => {
        let numberList: any = [];
        this.attendeeDDList.forEach(function (item: any) {
          numberList.push(item.attendeesUnoAtd);
        });
        for (let i = 0; i < data.length; i++) {
          data[i].dueDate = (data[i].dueDate && data[i].dueDate != '') ? data[i].dueDate : null;
          //
          let UserList = (data[i].responsibility != null && data[i].responsibility != '') ? data[i].responsibility.split(',').map(Number) : null;
          if (UserList)
            data[i].responsibility = UserList.filter(item => numberList.includes(item))
        }
        this.actionPointsList = data;

      },
        () => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }

  removeTags(str) {
    if ((str === null) || (str === ''))
      return str;
    else
      str = str.toString();
    return str.replace(/(<([^>]+)>)/ig, '');
  }

  printActionPointList() {
    let temp = this;
    let items: any = [];
    this.getMainActionPoints().forEach(function (row, idx) {
      items.push({
        SNo: idx + 1,
        ActionPoint: row.note,
        DueDate: row.dueDate,
        Responsibility: row.userName,
        Priority: row.priority
      });

      temp.getSubItems(row).forEach(function (subrow, subidx) {
        items.push({
          SNo: ((idx + 1) + '.' + (subidx + 1)).toString(),
          ActionPoint: subrow.note,
          DueDate: subrow.dueDate,
          Responsibility: subrow.userName,
          Priority: subrow.priority
        });
      });
    });
    return items;
  }

  printDiscussion() {
    let temp = this;
    let items: any = [];
    this.getMainDiscussedActions().forEach(function (row, idx) {
      items.push({
        SNo: idx + 1,
        ActionPoint: row.note
      });

      temp.getSubItems(row).forEach(function (subrow, subidx) {
        items.push({
          SNo: ((idx + 1) + '.' + (subidx + 1)).toString(),
          ActionPoint: subrow.note
        });
      });
    });
    return items;
  }

  exportDiscussion() {
    let temp = this;
    let items: any = [];
    this.getMainDiscussedActions().forEach(function (row, idx) {
      items.push({
        SNo: idx + 1,
        ActionPoint: temp.removeTags(row.note)
      });

      temp.getSubItems(row).forEach(function (subrow, subidx) {
        items.push({
          SNo: ((idx + 1) + '.' + (subidx + 1)).toString(),
          ActionPoint: temp.removeTags(subrow.note)
        });
      });
    });
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(items);
    const workbook: XLSX.WorkBook = { Sheets: { 'Discussion': worksheet }, SheetNames: ['Discussion'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    FileSaver.saveAs(blob, this.model.subjectAtd + '_DiscussionList.xlsx');

  }

  exportActionPoint() {
    let temp = this;
    let items: any = [];
    this.getMainActionPoints().forEach(function (row, idx) {
      items.push({
        SNo: idx + 1,
        ActionPoint: temp.removeTags(row.note),
        DueDate: row.dueDate,
        Responsibility: row.userName,
        Priority: row.priority
      });

      temp.getSubItems(row).forEach(function (subrow, subidx) {
        items.push({
          SNo: ((idx + 1) + '.' + (subidx + 1)).toString(),
          ActionPoint: temp.removeTags(subrow.note),
          DueDate: subrow.dueDate,
          Responsibility: subrow.userName,
          Priority: subrow.priority
        });
      });
    });
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(items);
    const workbook: XLSX.WorkBook = { Sheets: { 'ActionPoint': worksheet }, SheetNames: ['ActionPoint'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    FileSaver.saveAs(blob, this.model.subjectAtd + '_ActionPointList.xlsx');

  }

  getFileList(id, type) {
    return this.fileList.filter(item => item.docSectionId == id && item.docSection == type).length;
  }
  openFileList(id, type) {
    this.modalPub = this.modalService.show(this.templateFile, Object.assign({}, { class: 'modal-md' }));
    this.actionFileList = this.fileList.filter(item => item.docSectionId == id && item.docSection == type);
  }
  getMainActionPoints() {
    return this.actionPointsList.filter(item => item.agendaParentUno == 0);
  }
  getMainDiscussedActions() {
    return this.actionPointsList.filter(item => item.agendaParentUno == -1);
  }
  getSubItems(val: any) {
    return this.actionPointsList.filter(item => item.agendaParentUno == val.agendaUno);
  }

  haveSubItem(val: any) {
    return (this.actionPointsList.filter(item => item.agendaParentUno == val.agendaUno).length > 0) ? true : false;
  }

  deleteActionPoints(val: any) {
    let that = this;
    Notiflix.Confirm.Show('Confirm ', 'Are you sure you want to delete?', 'Yes', 'No', function () {
      let objAgenda = new AgendaDetails();
      objAgenda.agendaUno = val.agendaUno;
      objAgenda.userID = that.loginUserId;
      objAgenda.actionType = that.pagetype;
      that.momService.deleteAgenda(objAgenda)
        .subscribe(() => {
          that.toastr.DeleteMessage()
          that.getActionPointsList();
        },
          () => {
            that.toastr.ErrorMessage()

          }
        ).add(() => {
        });
    },
      function () { //('If you say so...');
      });
  }
  updateActionPoints(model) {
    this.apModel = model;
    this.apModel.genInfoAtdUno = this.model.genInfoAtdUno;
    this.apModel.userID = this.loginUserId;
    this.apModel.actionType = this.pagetype;
    this.momService.addEditAgenda(this.apModel)
      .subscribe(() => {
        this.toastr.SaveMessage();
        this.apModel = new AgendaDetails();
        this.isSubmitAP = false;
        this.getActionPointsList();
        this.modalRef.hide()
      },
        () => {
          this.toastr.ErrorMessage()
        }
      ).add(() => {

      });
  }

  openAddActionPoint(enable: boolean = true) {
    this.enableAP = enable;
    this.apModel = new AgendaDetails();
    this.apModel.agendaParentUno = enable ? 0 : -1;
    this.modalRef = this.modalService.show(this.templateActionPoint, { class: 'modal-md' });
  }

  opensubActionPoint(model, enable: boolean = true) {
    this.enableAP = enable;
    this.apModel = new AgendaDetails();
    this.apModel.agendaParentUno = model.agendaUno;
    this.modalRef = this.modalService.show(this.templateActionPoint, { class: 'modal-md' });
  }

  openEditActionPoint(model, enable: boolean = true) {
    this.enableAP = enable;
    this.apModel = model;
    this.apModel.dueDate = (this.apModel.dueDate && this.apModel.dueDate != '') ? formatDate(this.apModel.dueDate, 'yyyy-MM-dd', 'en-US') : null;
    this.modalRef = this.modalService.show(this.templateActionPoint, { class: 'modal-md' });
  }

  submitEditActionPoint(gf: NgForm) {
    if (gf.valid) {
      this.apModel.responsibility = this.apModel.responsibility ? this.apModel.responsibility.toString() : this.apModel.responsibility;
      this.updateActionPoints(this.apModel)
    }
    else {
      this.toastr.ValidationMessage();
      this.isSubmitAP = true;
    }
  }

  onSubmitActionPoint(gf: NgForm) {
    if (gf.valid) {
      this.apModel.priority = 'Low Priority';
      this.updateActionPoints(this.apModel)
    }
    else {
      this.toastr.ValidationMessage();
      this.isSubmitAP = true;
    }
  }

  closeActionPoint() {
    this.apModel = new AgendaDetails();
    this.isSubmitAP = false;
    this.modalRef.hide();
  }
  onChangeEdit() {
    if (this.model.published == 1) {
      Notiflix.Block.Dots('.editcancel');
      this.momTab1 = true;
      this.momTab2 = false;
      this.momTab3 = false;
      this.viewSelected = !this.viewSelected;
      this.editSelected = !this.editSelected;
      if (this.text === 'Edit') {
        this.text = 'Cancel'
      } else {
        this.text = 'Edit'
      };
      Notiflix.Block.Remove('.editcancel', 800);
    }
    else {

      this.attendanceEditUno = this.model.genInfoAtdUno;
      this.modalAdd = this.modalService.show(this.templateAdd, Object.assign({}, { class: 'gray modal-xl modal-full modal-dialog-scrollable modal-body-scrollable-hgt bg-opacity-light' }, this.ngbModalOptions)
      );
      let that = this;
      setTimeout(function () {
        that.closeModal();
        that.isModalShow = true;
      }, 400);
    }
  }


  getAttachFiles() {
    let inpValue = new FileAttachement();
    inpValue.generalInfoId = this.model.genInfoAtdUno;
    inpValue.attachmentUno = 0;
    inpValue.docType = this.docType;
    inpValue.actionType = this.pagetype;
    this.momService.GetFileList(inpValue)
      .subscribe(data => {

        this.fileList = data;
      },
        () => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  uploadAttachedFiles(typeId, typeName) {

    if (this.uploadedFiles.length > 10) {
      this.toastr.ErrorCustomMessage('Upload at the time 10 files only ');

      return;
    }

    if (this.uploadedFiles.length == 0) {
      this.toastr.ErrorCustomMessage('Please Choose the file ');
      return;
    }
    let formData = new FormData();
    for (let i = 0; i < this.uploadedFiles.length; i++) {
      formData.append("file", this.uploadedFiles[i]);

      if (this.uploadedFiles[i].size > 20971520) {
        this.toastr.ErrorCustomMessage('You can upload Max. of 20MB files only - ' + this.uploadedFiles[i].name);

        return;
      }
    }
    formData.append("id", this.model.genInfoAtdUno ? this.model.genInfoAtdUno.toString() : '');
    formData.append("userId", this.loginUserId ? this.loginUserId.toString() : '');
    formData.append("flength", this.fileList.length);
    formData.append("pagetype", this.pagetype);
    formData.append("typename", typeName);
    formData.append("typeid", typeId);
    this.momService.UploadFiles(formData)
      .subscribe(() => {
        this.toastr.SuccessCustomMessage("Successfully Uploaded.");
        this.getAttachFiles();
        this.uploadedFiles = [];
        (<HTMLInputElement>document.getElementById('commentFile')).value = "";
      },
        (error) => {
          this.toastr.ErrorMessage()

        }
      ).add(() => {
      });

  }
  openFileRename(template: TemplateRef<any>, data: any) {
    this.attachmentUno = data.attachmentUno;
    this.model1.fileName = data.fileName;
    this.fileRename = this.modalService.show(template, Object.assign({}, { class: 'modal-md' }, this.ngbModalOptions));
  }
  renameFile() {
    let that = this;
    let objFile = new FileAttachement();
    objFile.attachmentUno = this.attachmentUno;
    objFile.fileName = this.model1.fileName;
    objFile.userId = that.loginUserId;
    objFile.actionType = "ATTENDANCE-FILE";
    that.momService.deleteAttachedFile(objFile)
      .subscribe(() => {
        that.toastr.SuccessCustomMessage("Successfully Updated")
        that.getAttachFiles();
        this.fileRename.hide();

      },
        () => {
          that.toastr.ErrorMessage()

        }
      ).add(() => {
      });
  }
  onDeleteFiles(data: any) {
    let that = this;
    Notiflix.Confirm.Show('Confirm ', 'Are you sure you want to delete?', 'Yes', 'No', function () {
      let objFile = new FileAttachement();
      objFile.attachmentUno = data.attachmentUno;
      objFile.contentType = data.contentType;
      objFile.fileName = data.fileName;
      objFile.generalInfoId = data.generalInfoId;
      objFile.userId = that.loginUserId;
      objFile.actionType = that.pagetype;
      that.momService.deleteAttachedFile(objFile)
        .subscribe(() => {
          that.getAttachFiles();
          that.toastr.DeleteMessage();
          

        },
          () => {
            that.toastr.ErrorMessage()

          }
        ).add(() => {
        });
    },
      function () { //('If you say so...');
      });

  }
  commentFileInput(file: FileList) {
    for (let i = 0; i < file.length; i++) {
      this.uploadedFiles.push(file[0]);
      this.commentText = 'File: ' + file[0].name;
    }
    this.AddComment();
    this.uploadAttachedFiles(this.loginUserId, 'Comment');
  }
  downloadCommentFile() {
    this.modalPub = this.modalService.show(this.templateFile, Object.assign({}, { class: 'modal-md' }));
    this.actionFileList = this.fileList.filter(item => item.docSection == 'Comment');
  }
  actionPointFileInput(file: FileList, item) {
    for (let i = 0; i < file.length; i++) {
      this.uploadedFiles.push(file[0]);
    }
    this.uploadAttachedFiles(item.agendaUno, 'ActionPoint');
  }
  DownloadFiles(fileObj) {
    fileObj.actionType = this.pagetype;
    this.momService.downloadAttachFile(this.FileType(fileObj.fileName), fileObj);
  }

  FileType(fileName) {
    //file type extension
    let checkFileType = fileName.split('.').pop();
    var fileType;
    if (checkFileType == "txt") {
      fileType = "text/plain";
    }
    if (checkFileType == "pdf") {
      fileType = "application/pdf";
    }
    if (checkFileType == "doc" || checkFileType == "docx") {
      fileType = "application/vnd.ms-word";
    }
    if (checkFileType == "pptx" || checkFileType == "ppt") {
      fileType = "application/vnd.ms-powerpoint";
    }
    if (checkFileType == "xls" || checkFileType == "xlsx") {
      fileType = "application/vnd.ms-excel";
    }
    if (checkFileType == "png") {
      fileType = "image/png";
    }
    if (checkFileType == "jpg") {
      fileType = "image/jpeg";
    }
    if (checkFileType == "jpeg") {
      fileType = "image/jpeg";
    }
    if (checkFileType == "gif") {
      fileType = "image/gif";
    }
    if (checkFileType == "csv") {
      fileType = "text/csv";
    }
    if (checkFileType == 'mp4' || checkFileType == 'm4a') {
      fileType = "video/mpeg";
    }
    return fileType
  }

  checkFileType(fileName) {


    //file type extension
    let checkFileType = fileName.split('.').pop();
    var fileType;
    if (checkFileType == "txt") {
      fileType = "la-file-text";
    }
    if (checkFileType == "pdf") {
      fileType = "la-file-pdf-o";
    }
    if (checkFileType == "doc" || checkFileType == "docx") {
      fileType = "la-file-word-o";
    }
    if (checkFileType == "pptx" || checkFileType == "ppt") {
      fileType = "la-file-powerpoint-o";
    }
    if (checkFileType == "xls" || checkFileType == "xlsx") {
      fileType = "la-file-excel-o";
    }
    if (checkFileType == "png") {
      fileType = "la-file-image-o";
    }
    if (checkFileType == "jpg") {
      fileType = "la-file-image-o";
    }
    if (checkFileType == "jpeg") {
      fileType = "la-file-image-o";
    }
    if (checkFileType == "gif") {
      fileType = "la-file-video-o";
    }
    if (checkFileType == "csv") {
      fileType = "la-file-o";
    }
    if (checkFileType == 'mp4' || checkFileType == 'm4a') {
      fileType = "la-file-video-o";
    }
    return fileType;
  }

  profileCard(id) {
    if (this.isProfileCard == false) {
      this.isProfileCard = true;
      let link: any = document.getElementById(id);
      link.classList.add('d-block');
      link.classList.add('d-block');
    }
  }

  closeCard(id) {
    this.isProfileCard = false;
    let link: any = document.getElementById(id);
    link.classList.remove('d-block');
  }
  gerPriortyColor(priority: string) {
    return priority.includes('Low') ? 'bg-primary' : (priority.includes('High') ? 'bg-danger' : 'bg-warning');
  }


  onChangemomTab(selectedTab: any) {
    ;
    if (selectedTab == 'general') {
      this.momTab1 = true;
      this.momTab2 = false;
      this.momTab3 = false;
    }
    else if (selectedTab == 'chat') {
      this.momTab1 = false;
      this.momTab2 = true;
      this.momTab3 = false;
      this.getCommentList();
    }
    else if (selectedTab == 'files') {
      this.momTab1 = false;
      this.momTab2 = false;
      this.momTab3 = true;
      this.getAttachFiles();
    }
    return false;
  }

  onChangesubTab(selectedTab: any) {
    ;
    if (selectedTab == 'internal') {
      this.addTab1 = true;
      this.addTab2 = false;
    }
    else if (selectedTab == 'external') {
      this.addTab1 = false;
      this.addTab2 = true;
    }
    return false;
  }

  onChangeTab(selectedTab: any) {

    if (selectedTab == 'details') {
      this.selTab1 = true;
      this.selTab2 = false;
      this.selTab3 = false;
      this.selTab4 = false;
      this.selTab5 = false;
    }
    else if (selectedTab == 'attendees') {
      this.selTab1 = false;
      this.selTab2 = true;
      this.selTab3 = false;
      this.selTab4 = false;
      this.selTab5 = false;
      this.getAttendeeList();
    }
    else if (selectedTab == 'Workflow') {
      this.selTab1 = false;
      this.selTab2 = false;
      this.selTab3 = true;
      this.selTab4 = false;
      this.selTab5 = false;
    }
    else if (selectedTab == 'actionspoints') {
      this.selTab1 = false;
      this.selTab2 = false;
      this.selTab3 = false;
      this.selTab4 = true;
      this.selTab5 = false;
      this.getActionPointsList();
    }
    else if (selectedTab == 'files') {
      this.selTab1 = false;
      this.selTab2 = false;
      this.selTab3 = false;
      this.selTab4 = false;
      this.selTab5 = true;
      this.getAttachFiles();
    }

    return false;
  }


  downloadPDFMeeting() {
    ;
    pdfMake.fonts = {
      DroidKufi: {
        normal: 'DroidKufi-Regular.ttf',
        bold: ' DroidKufi-Regular.ttf',
        italics: 'DroidKufi-Regular.ttf',
        bolditalics: 'DroidKufi-Regular.ttf'
      },
      NotoKufiArabic: {
        normal: 'NotoKufiArabic-Regular.ttf',
        bold: ' NotoKufiArabic-Regular.ttf',
        italics: 'NotoKufiArabic-Regular.ttf',
        bolditalics: 'NotoKufiArabic-Regular.ttf'

      },
      Roboto: {
        normal: 'Roboto-Regular.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Italic.ttf',
        bolditalics: 'Roboto-Italic.ttf'
      },
    };
    const documentDefinition = this.getMeetingDefinition();
    pdfMake.createPdf(documentDefinition).download('MOM - ' + this.model.subjectAtd.split('.').join(' '));

  }


  updateMeetingStatus(type) {
    
    if (type == 'MSENDREVIEW' && this.reviewerList.length == 0) {
      this.toastr.ErrorCustomMessage('Please configure the workflow setup')
      return;
    }
    
    if (this.isLoading)
      return;

    let temp = this;
    temp.isLoading = true;
    let inpValue = new GenInfoAtd();
    inpValue.userUno = this.loginUserId;
    inpValue.genInfoAtdUno = this.model.genInfoAtdUno;
    inpValue.actionType = type;
    inpValue.recordType = 1;
    inpValue.momNoAtd = this.model.subjectAtd.split('.').join(' ');
    inpValue.enteredBy = this.model.enteredBy;
    pdfMake.fonts = {
      DroidKufi: {
        normal: 'DroidKufi-Regular.ttf',
        bold: ' DroidKufi-Regular.ttf',
        italics: 'DroidKufi-Regular.ttf',
        bolditalics: 'DroidKufi-Regular.ttf'
      },
      NotoKufiArabic: {
        normal: 'NotoKufiArabic-Regular.ttf',
        bold: ' NotoKufiArabic-Regular.ttf',
        italics: 'NotoKufiArabic-Regular.ttf',
        bolditalics: 'NotoKufiArabic-Regular.ttf'

      },
      Roboto: {
        normal: 'Roboto-Regular.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Italic.ttf',
        bolditalics: 'Roboto-Italic.ttf'
      },
    };
    setTimeout(function () {
      const documentDefinition = temp.getMeetingDefinition();
      pdfMake.createPdf(documentDefinition).getBase64(function (encodedString) {
        inpValue.pdfContent = encodedString;
        temp.momService.attendancePublishGeneralInfo(inpValue)
          .subscribe(data => {
            temp.toastr.UpdateMessage();
            temp.isLoading = false;
            temp.closeModal()
            if (type = 'MPUBLISH')
              temp.modalPub.hide();
          },
            () => {
              temp.isLoading = false;
              temp.toastr.ErrorMessage();
            }
          )

      });
    }, 5000);
  }

  DayAsString(dayIndex) {
    var weekdays = new Array(7);
    weekdays[0] = "Sunday";
    weekdays[1] = "Monday";
    weekdays[2] = "Tuesday";
    weekdays[3] = "Wednesday";
    weekdays[4] = "Thursday";
    weekdays[5] = "Friday";
    weekdays[6] = "Saturday";

    return weekdays[dayIndex];
  }
  getLanguageStyle(value: string) {
    let strLanguage = 'en';
    var arabic = /[\u0600-\u06FF]/;
    if (value !== null && value !== '') {
      value = value.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '')
      value = value.replace(/\n/g, "");
      value = value.replace(/\r/g, "");
      if (arabic.test(value)) {
        strLanguage = "ar";
      } else {
        strLanguage = "en";
      }
    } else {
      strLanguage = "en";
    }

    return (strLanguage == 'en') ? 'en_lang' : 'ar_lang';
  }

  FormatDate(val) {
    if (val == null || val == undefined || val == '')
      return 'TBD';
    else
      return formatDate(val.toString(), 'dd/MM/yyyy', 'en-US')
  }

  CoverttoTime(val) {
    if (val == null || val == undefined || val == '')
      return '';
    else
      return formatDate(new Date(this.model.fMeetingDateAtd + ' ' + val), 'hh:mm a', 'en-US')
  }

  getMeetingDefinition() {
    let temp = this;
    let currentYear: any = new Date().getFullYear();
    return {
      pageMargins: [30, 100, 30, 60],
      footer: function (currentPage, pageCount) {
        return [
          {
            text: 'Page ' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', fontSize: 8, color: 'grey', margin: [30, 20, 30, -35],
          },

          { text: 'Created Date: ' + formatDate(temp.model.createDate, 'dd/MM/yyyy', 'en-US'), alignment: 'left', margin: [30, 20, 30, 20], color: 'grey', fontSize: 8, },
          {
            text: '© ' + currentYear +' Dubai Electricity and Water Authority PJSC. All Rights Reserved.', alignment: 'center', fontSize: 8, color: 'grey', border: [false, true, false, false], margin: [0, 5, 0, 10], width: ['*']
          }];
      },
      header: {
        margin: [30, 20, 30, 20],
        table: {
          widths: ['*', '*', '*'],
          body: [
            [
              {
                border: [false, false, false, false],
                image: this.userService.dubaiLogo,
                fit: [100, 160],
                //image: this.userService.dewaLogo,
                //fit: [160, 160],
                alignment: 'left',
                margin: [-10, 10, 0, 0],
              },
              {
                border: [false, false, false, false],
                text: 'Minutes Of Meeting',
                bold: true,
                fontSize: 15,
                alignment: 'center',
                margin: [0, 22, 30, 10],
              },
              {
                border: [false, false, false, false],
                image: this.userService.dewaLogo,
                fit: [160, 160],
                margin: [12, 10, 0, 10],
                //image: this.userService.dubaiLogo,
                //fit: [100, 100],
                //margin: [20, 10],
                //alignment: 'left',
              },
            ],
          ]
        },
      },
      content: [
        {
          style: 'tableExample',
          table: {
            widths: [55, '*'],

            body: [

              [

                { text: 'Subject', fillColor: '#d9d9d9', noWrap: true, bold: true },
                { text: this.model.subjectAtd, style: this.getLanguageStyle(this.model.subjectAtd) }
              ],
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 1 : 1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 1 : 1;
            },
            hLineColor: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 'gray' : 'gray';
            },
            vLineColor: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 'gray' : 'gray';
            },
          },
        },

        {
          style: 'tableExample',
          table: {
            widths: [55, 165, 48.5, 229.5],

            body: [
              [{ text: 'Meeting Number', fillColor: '#d9d9d9', bold: true, border: [true, false, true, true], },
              { text: this.model.momNoAtd, border: [true, false, true, true], },
              { text: 'Meeting Room', fillColor: '#d9d9d9', bold: true, border: [true, false, true, true] },
              { text: this.model.meetingRoomName, border: [true, false, true, true], style: this.getLanguageStyle(this.model.meetingRoomName) },

              ],

            ],

          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 1 : 1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 1 : 1;
            },
            hLineColor: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 'gray' : 'gray';
            },
            vLineColor: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 'gray' : 'gray';
            },
          },
        },
        {
          style: 'tableExample',
          table: {
            widths: [55, 65, 20, 62, 48.5, '*'],
            body: [
              [{ text: 'Date', noWrap: true, fillColor: '#d9d9d9', bold: true, border: [true, false, true, true] },
              { text: formatDate(this.model.fMeetingDateAtd, 'dd/MM/yyyy', 'en-US'), border: [true, false, true, true] },
              { text: 'Day', noWrap: true, fillColor: '#d9d9d9', bold: true, border: [true, false, true, true] },
              { text: this.DayAsString(new Date(this.model.fMeetingDateAtd).getDay()), border: [true, false, true, true] },
              { text: 'Time', noWrap: true, fillColor: '#d9d9d9', bold: true, border: [true, false, true, true] },
              { text: this.CoverttoTime(this.model.fStartTimeAtd) + ' to ' + this.CoverttoTime(this.model.fEndTimeAtd), border: [true, false, true, true] }],
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 1 : 1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 1 : 1;
            },
            hLineColor: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 'gray' : 'gray';
            },
            vLineColor: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 'gray' : 'gray';
            },
          },
        },

        { text: 'Attendees', ineHeight: 2, margin: [0, 10, 0, 0], style: 'subheader', bold: true },
        {
          table: {
            headerRows: 1,
            widths: ['*', '*'],
            body: [
              [{ text: 'Name', style: 'tableHeader', bold: true, fillColor: '#dddddd', border: [true, true, true, true] }, { text: 'Attendance', style: 'tableHeader', bold: true, fillColor: '#dddddd', border: [true, true, true, true] }],
              ...this.attendeeDDList.map(e => ([e.nameAtd, e.status]))
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 1 : 1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 1 : 1;
            },
            hLineColor: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 'gray' : 'gray';
            },
            vLineColor: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 'gray' : 'gray';
            },
          },
        },


        //{ text: 'Action Points', ineHeight: 2, margin: [0, 10, 0, 0], style: 'subheader', bold: true },
        //{
        //  table: {
        //    widths: ['auto', '*', 'auto', 'auto', 'auto'],
        //    headerRows: 1,
        //    body: [
        //      [{ text: 'S.No.', style: 'tableHeader', bold: true, fillColor: '#dddddd', border: [true, true, true, true] },
        //      { text: 'Action Point', style: 'tableHeader', bold: true, fillColor: '#dddddd', border: [true, true, true, true] },
        //      { text: 'Responsibility', style: 'tableHeader', bold: true, fillColor: '#dddddd', border: [true, true, true, true] },
        //      { text: 'Due Date', style: 'tableHeader', bold: true, fillColor: '#dddddd', border: [true, true, true, true] },
        //      { text: 'Priority', style: 'tableHeader', bold: true, fillColor: '#dddddd', border: [true, true, true, true] }],
        //      ...this.printActionPointList().map(e => ([e.SNo, htmlToPdfmake(e.ActionPoint), e.Responsibility, temp.FormatDate(e.DueDate), e.Priority.replace('Priority', '')]))
        //    ]
        //  },
        //  layout: {
        //    hLineWidth: function (i, node) {
        //      return (i === 0 || i === node.table.body.length) ? 1 : 1;
        //    },
        //    vLineWidth: function (i, node) {
        //      return (i === 0 || i === node.table.widths.length) ? 1 : 1;
        //    },
        //    hLineColor: function (i, node) {
        //      return (i === 0 || i === node.table.body.length) ? 'gray' : 'gray';
        //    },
        //    vLineColor: function (i, node) {
        //      return (i === 0 || i === node.table.widths.length) ? 'gray' : 'gray';
        //    },
        //  },
        //},



        //{ text: 'Meeting Discussions', ineHeight: 2, margin: [0, 10, 0, 0], style: 'subheader', bold: true },
        //{
        //  table: {
        //    widths: ['auto', '*'],
        //    headerRows: 1,
        //    body: [
        //      [{ text: 'S.No.', style: 'tableHeader', bold: true, fillColor: '#dddddd', border: [true, true, true, true] },
        //      { text: 'Discussed Point', style: 'tableHeader', bold: true, fillColor: '#dddddd', border: [true, true, true, true] }],
        //      ...this.printDiscussion().map(e => ([e.SNo, htmlToPdfmake(e.ActionPoint)]))
        //    ]
        //  },
        //  layout: {
        //    hLineWidth: function (i, node) {
        //      return (i === 0 || i === node.table.body.length) ? 1 : 1;
        //    },
        //    vLineWidth: function (i, node) {
        //      return (i === 0 || i === node.table.widths.length) ? 1 : 1;
        //    },
        //    hLineColor: function (i, node) {
        //      return (i === 0 || i === node.table.body.length) ? 'gray' : 'gray';
        //    },
        //    vLineColor: function (i, node) {
        //      return (i === 0 || i === node.table.widths.length) ? 'gray' : 'gray';
        //    },
        //  },
        //},


        {
          alignment: 'justify',
          margin: [0, 20, 0, 0],
          columns: [
            [{


              alignment: 'left',
              text: 'Initiated By ',
              bold: true,
              margin: [0, 0, 0, 0],
            },

            ],
            //[
            //  {
            //    text: 'Reviewed By ',
            //    alignment: 'center',
            //    bold: true,
            //    margin: [0, 0, 0, 0],
            //  },


            //],

            //[


            //  {
            //    text: 'Approved By ',
            //    alignment: 'center',
            //    bold: true,
            //    margin: [0, 0, 0, 0],
            //  },


            //]

          ],
        },


        {
          alignment: 'justify',
          margin: [0, 10, 0, 0],
          columns: [
            [{


              alignment: 'left',
              text: this.model.initiatedBy,
              bold: false,
              margin: [0, 0, 0, 0],
            },

            ],
            //[...this.reviewerList.map(e => [{
            //  text: e.nameAtd,
            //  alignment: 'center',
            //  bold: false,
            //  margin: [0, 0, 0, 0],
            //}])],

            //[
            //  {
            //    text: this.approver ? this.approver.nameAtd : '',
            //    alignment: 'center',
            //    bold: false,
            //    margin: [0, 0, 0, 0],
            //  },


            //]

          ],
        },


      ],

      styles: {
        ar_lang: {
          font: 'NotoKufiArabic',
        },
        en_lang: {
          font: 'Roboto',
        },
        newline: {
          content: "-",
          display: 'block'
        },

      },


    }



  }
  changeFileFilter(value: any) {
    this.docType = value;
    this.getAttachFiles();
  }

  searchGrid() {
    ;
    if (this.searchText != "") {
      this.commentAttendeeList = this.commentChatList.filter(a =>
        a.name && a.name.toLowerCase().includes(this.searchText.toLowerCase())
      );
    }
    else
      this.commentAttendeeList = this.commentChatList;
  }
}
